<template>
	<div class="form-group">
		<label :for="props.id" class="required-field">{{ props.label }}</label>
		<div class="file-input-container">
			<input type="file" :id="props.id" @change="$emit('change', $event)" :accept="props.accept" ref="inputRef" required class="file-input" />
			<div class="file-input-overlay">
				<i :class="['fas', props.icon, 'me-2']"></i>
				<span>{{ props.value ? props.value.name : 'Seleccionar archivo' }}</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const props = withDefaults(
	defineProps<{
		id: string
		label: string
		accept: string
		icon: string
		value: File | null
	}>(),
	{
		value: null
	}
)

const inputRef = ref<HTMLInputElement | null>(null)
</script>

<style scoped>
.file-input-container {
	position: relative;
	margin-top: 0.5rem;
}

.file-input {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	cursor: pointer;
	z-index: 2;
}

.file-input-overlay {
	padding: 0.75rem 1rem;
	background-color: white;
	border: 2px dashed #dee2e6;
	border-radius: 8px;
	text-align: center;
	color: #6c757d;
	transition: all 0.3s ease;
}

.file-input:hover + .file-input-overlay {
	border-color: #0d6efd;
	color: #0d6efd;
}

.required-field::after {
	content: '*';
	color: #dc3545;
	margin-left: 4px;
}

.me-2 {
	margin-right: 0.5rem;
}
</style>
